import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './styles/Navbar.css'; 
import logo from './images/logo.png'; 
import Web3 from 'web3'; // Import Web3 library
import { useWallet } from './WalletContext.js';
import { getOpenSeaAccountName } from './api/opensea.js'; // Import the getOpenSeaAccountName function

function Navbar() {
  const location = useLocation();
  const { walletAddress, setWalletAddress } = useWallet();
  const [hovered, setHovered] = useState(false); // Define hovered state
  const [username, setUsername] = useState(''); // State to store the username

  useEffect(() => {
    const storedWalletAddress = localStorage.getItem('walletAddress');
    if (storedWalletAddress) {
      setWalletAddress(storedWalletAddress);
      fetchUsername(storedWalletAddress);
    }
  }, [setWalletAddress]);

  // Keep the app in sync when the user switches MetaMask accounts
  useEffect(() => {
    if (!window.ethereum) return;
    const handleAccountsChanged = (accounts) => {
      const addr = accounts[0] || '';
      setWalletAddress(addr);
      if (addr) {
        localStorage.setItem('walletAddress', addr);
        fetchUsername(addr);
      } else {
        localStorage.removeItem('walletAddress');
        setUsername('');
      }
    };
    window.ethereum.on('accountsChanged', handleAccountsChanged);
    return () => window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Function to fetch username from OpenSea API
  const fetchUsername = async (address) => {
    if (address) {
      const username = await getOpenSeaAccountName(address);
      setUsername(username);
    }
  };

  // Function to connect/disconnect Metamask and get wallet address
  const handleWalletAction = async () => {
    if (walletAddress) {
      // Disconnect wallet
      setWalletAddress('');
      setUsername(''); // Reset username
      localStorage.removeItem('walletAddress'); // Remove wallet address from localStorage
    } else {
      // Connect wallet
      if (window.ethereum) {
        try {
          await window.ethereum.request({ method: 'eth_requestAccounts' });
          const web3 = new Web3(window.ethereum);
          const accounts = await web3.eth.getAccounts();
          const address = accounts[0];
          setWalletAddress(address);
          fetchUsername(address); // Fetch username after connecting wallet
          localStorage.setItem('walletAddress', address); // Store wallet address in localStorage
        } catch (error) {
          console.error('Error connecting wallet:', error);
        }
      } else {
        console.error('Metamask not installed');
      }
    }
  };

  const rawPath = location.pathname;
  const path = rawPath.replace(/\/$/, '') || '/';
  const statsActive = path === '/stats' || path === '/';
  const mythicsActive = path.startsWith('/mythics');
  const leaderboardActive = path.startsWith('/leaderboard');

  const walletLabel = walletAddress
    ? hovered
      ? 'DISCONNECT'
      : (username && username !== 'Unknown'
          ? username
          : `${walletAddress.slice(0, 5)}…${walletAddress.slice(-4)}`)
    : 'CONNECT';

  return (
    <nav className="navbar" aria-label="Main">
      <div className="navbar-wallet-bar">
        <button
          type="button"
          className={`navbar-wallet-btn${walletAddress ? ' navbar-wallet-btn--connected' : ''}`}
          onClick={handleWalletAction}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {walletLabel}
        </button>
      </div>

      <div className="navbar-main">
        <Link to="/stats" className="navbar-logo">
          <img src={logo} alt="Yellow Mythics" />
        </Link>

        <div className="navbar-tabs" role="navigation" aria-label="Site sections">
          <Link
            to="/stats"
            className={`navbar-tab${statsActive ? ' navbar-tab--active' : ''}`}
          >
            Stats
          </Link>
          <Link
            to="/mythics"
            className={`navbar-tab${mythicsActive ? ' navbar-tab--active' : ''}`}
          >
            Mythics
          </Link>
          <Link
            to="/leaderboard"
            className={`navbar-tab${leaderboardActive ? ' navbar-tab--active' : ''}`}
          >
            Leaderboard
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
